/*defines unique error code to associate 'pretty' messages to the user */
spanplusApp.provider('AppErrorCodes', function () {
    var errCodes = {
        'Global_Unknown': 'Global_Unknown',
        'LoginController_NotAuthenticated': 'NotAuthenticated',
        'LoginController_PasswordResetFail':'PasswordResetFail',
        'Dealer_Not_Found': 'Dealer_Not_Found',
        'LoginController_PasswordResetValidation':'PasswordResetValidation',
        'VehicleController_VehicleInfoError' : 'VehicleInfoError',
        'VehicleController_VinDecodeError' : 'VinDecodeError',
        'CreateQuoteController_LoadQuoteError' : 'LoadQuoteError',
        'CreateQuoteController_ProductError' : 'ProductError',
        'CreateQuoteController_RateError' : 'RateError',
        'CreateQuoteController_SaveQuoteError' : 'SaveQuoteError',
        'CreateQuoteController_MenuTransferError' : 'MenuTransferError',
        'LenderController_LoadLendersError' : 'LoadLendersError',
        'LenderController_DeleteLendersError' : 'DeleteLendersError',
        'LenderController_SaveLendersError' : 'SaveLendersError',
        'LenderController_GetALenderError' : 'GetALenderError',
        'LenderController_LoadStatesError' : 'LoadStatesError',
        'QuoteContractController_MissingInfoError' : 'MissingInfoError',
        'QuoteContractController_ContractCreateError' : 'ContractCreateError',
        'DealInfoController_LoadLendersError' : 'LoadLendersError',
        'DealInfoController_SaveLendersError' : 'SaveLendersError',
        'IntegrationController_NoUserError' : 'NoUserError',
        'IntegrationController_GeneralError' : 'IntegrationError',
        'QuoteQueueController_GeneralError' : 'QuoteQueueError',
        'QuoteQueueController_ContractError' : 'ContractCreateError',
        'QuoteQueueController_AltFinanceError' : 'AltFinanceError',
        'QuoteScenarioController_GeneralError' : 'QuoteScenarioError',
        'ProductController_DisplaySettingError' : 'DisplaySettingError',
        'DealerController_GetDealerError' : 'GetDealerError',
        'DealerController_LoadStatesError' : 'LoadStatesError',
        'DealerController_SaveDealerError' : 'SaveDealerError',
        'DealerPackController_GeneralError' : 'DealerPackError',
        'DealerPrefController_GeneralError' : 'DealerPrefError',
        'DealerProductProfileController_GeneralError': 'DealerProdProfileError',
        'DealerPrefController_SaveError' : 'DealerPrefSaveError',
        'DealerSearchController_LoadStatesError' : 'LoadStatesError',
        'DealerSearchController_GeneralError' : 'DealerSearchError',
        'ProfitSettingController_GeneralError' : 'ProfitSettingError',
        'ProfitSettingController_SaveError' : 'ProfitSettingSaveError',
        'SettingsSummaryController_GeneralError' : 'SettingsSummaryError',
        'SearchController_GeneralError' : 'SearchError',
        'UserController_GeneralError' : 'ManageUserError',
        'UserController_SaveError' : 'SaveUserError',
        'UserController_PasswordResetError' : 'PasswordResetError',
        'UserHierarchyController_GeneralError' : 'UserHierarchyError',
        'UserHierarchyController_UserAssocError' : 'UserHierarchyAssociateError',
        'UserSearchController_GeneralError' : 'SearchUserError',
        'SSOIntegrationController_GeneralError' : 'SSOIntegrationError',
        'ZipService_Error' : 'ZipServiceError',
    };
    this.$get = [function() {
        return errCodes;
    }];
});
